/* =====================================================================
   FREE GIFT — global handlers called directly via inline onclick.
   Defined at the very top so they always exist, independent of load order.
   ===================================================================== */
window.novioreFreeGiftRefresh = function (data) {
  var cart = document.querySelector('cart-container');
  if (cart && typeof cart.reloadCartElements === 'function' && data && data.sections) {
    cart.reloadCartElements(data.sections);
  }
  try { window.dispatchEvent(new CustomEvent('kt.cart.added', { detail: data || {} })); } catch (e) {}
  var drawer = document.querySelector('#offcanvas-cart');
  if (drawer && window.bootstrap && window.bootstrap.Offcanvas) {
    window.bootstrap.Offcanvas.getOrCreateInstance(drawer).show();
  }
};

window.novioreAddGift = function (event, variantId, btn) {
  if (event) { event.preventDefault(); event.stopPropagation(); }
  variantId = Number(variantId);
  if (!variantId) { if (btn) btn.textContent = 'No variant id'; return false; }
  if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
  var addUrl = (window.Shopify && Shopify.routes && Shopify.routes.cart_add_url) ? Shopify.routes.cart_add_url : '/cart/add';
  fetch(addUrl + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({
      items: [{ id: variantId, quantity: 1, properties: { _free_gift: 'true' } }],
      sections: ['cart-count-badge', 'offcanvas-cart'],
      sections_url: window.location.pathname
    })
  }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
    .then(function (res) {
      if (res.ok) { if (btn) btn.textContent = 'Added'; window.novioreFreeGiftRefresh(res.d); }
      else { if (btn) { btn.disabled = false; btn.textContent = 'Error: ' + ((res.d && res.d.description) || 'failed'); } console.warn('[free-gift] add failed', res.d); }
    })
    .catch(function (err) { if (btn) { btn.disabled = false; btn.textContent = 'Network error'; } console.warn('[free-gift] add error', err); });
  return false;
};

window.novioreRemoveGift = function (event, key, btn) {
  if (event) { event.preventDefault(); event.stopPropagation(); }
  if (!key) return false;
  if (btn) btn.disabled = true;
  var changeUrl = (window.Shopify && Shopify.routes && Shopify.routes.cart_change_url) ? Shopify.routes.cart_change_url : '/cart/change';
  fetch(changeUrl + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: key, quantity: 0, sections: ['cart-count-badge', 'offcanvas-cart'], sections_url: window.location.pathname })
  }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
    .then(function (res) { if (res.ok) window.novioreFreeGiftRefresh(res.d); })
    .catch(function () {});
  return false;
};

document.addEventListener('DOMContentLoaded', function() {
  if (!document.getElementById('theme-overlay')) {
    const overlay = document.createElement('div');
    overlay.id = 'theme-overlay';
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.background = 'rgba(0, 0, 0, 0.8)';
    overlay.style.color = 'white';
    overlay.style.display = 'flex'; // Shown initially
    overlay.style.alignItems = 'center';
    overlay.style.justifyContent = 'center';
    overlay.style.fontSize = '24px';
    overlay.style.zIndex = '9999';
    overlay.style.textAlign = 'center';
    overlay.innerText = 'Enter a valid license to access this theme.';
    document.body.appendChild(overlay);
  }
  const storeUrl = window.location.hostname;
  if (validateLicense(storeUrl)) {
    document.getElementById('theme-overlay').style.display = 'none'; // Hide overlay
  } else {
    document.getElementById('theme-overlay').style.display = 'flex'; // Show overlay
  }
 
});
  function validateLicense(url) {
    const validStoreUrls = [
      "m0nfwe-tm.myshopify.com",
      "127.0.0.1",
      "localhost",
      "www.noviore.com",
      "noviore.com",
      "www.billamama.com",
      "billamama.com"
    ];
    return validStoreUrls.includes(url) || url.endsWith(".shopifypreview.com") || url.endsWith("billamama.com");
  }

/* =====================================================================
   FEATURE 2 — Search: typewriter placeholder + popular searches
   ===================================================================== */
(function () {
  function initSearchTypewriter () {
    document.querySelectorAll('input[data-typewriter="true"]').forEach((input) => {
      if (input.dataset.typewriterInit === '1') return
      input.dataset.typewriterInit = '1'

      const terms = (input.dataset.typewriterTerms || '')
        .split(',')
        .map((t) => t.trim())
        .filter(Boolean)
      if (!terms.length) return

      let i = 0
      let j = 0
      let deleting = false

      const tick = () => {
        // Don't fight the user while they are typing
        if (input.value) {
          setTimeout(tick, 700)
          return
        }
        const word = terms[i]
        if (!deleting) {
          j++
          input.setAttribute('placeholder', word.slice(0, j))
          if (j >= word.length) {
            deleting = true
            setTimeout(tick, 1400)
            return
          }
          setTimeout(tick, 70)
        } else {
          j--
          input.setAttribute('placeholder', word.slice(0, j))
          if (j <= 0) {
            deleting = false
            i = (i + 1) % terms.length
            setTimeout(tick, 300)
            return
          }
          setTimeout(tick, 40)
        }
      }
      tick()
    })
  }

  function initPopularSearches () {
    document.querySelectorAll('.search-popular-term').forEach((a) => {
      if (a.dataset.popularInit === '1') return
      a.dataset.popularInit = '1'

      a.addEventListener('click', (e) => {
        const drawer = a.closest('.offcanvas-search') || document
        const input = drawer.querySelector('input[type="search"]')
        if (input) {
          e.preventDefault()
          input.value = a.dataset.term || a.textContent.trim()
          input.dispatchEvent(new Event('input', { bubbles: true }))
          input.focus()
        }
      })
    })
  }

  function initSearchExtras () {
    initSearchTypewriter()
    initPopularSearches()
  }

  if (document.readyState !== 'loading') {
    initSearchExtras()
  } else {
    document.addEventListener('DOMContentLoaded', initSearchExtras)
  }
})()

/* =====================================================================
   FEATURE 4 — Mobile menu drawer banner carousel (partial slide, full bleed)
   ===================================================================== */
(function () {
  function buildMenuBannerSwiper () {
    const menu = document.querySelector('#offcanvas-menu')
    if (!menu) return
    const el = menu.querySelector('.menu-banner-carousel')
    if (!el || el.dataset.swiperInit === '1' || typeof Swiper === 'undefined') return

    el.dataset.swiperInit = '1'
    const autoplay = el.dataset.autoplay === 'true'

    // eslint-disable-next-line no-new
    new Swiper(el, {
      slidesPerView: 1.15,
      spaceBetween: 12,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      loop: false,
      autoplay: autoplay ? { delay: 3500, disableOnInteraction: false } : false
    })
  }

  function initMenuBanner () {
    const menu = document.querySelector('#offcanvas-menu')
    if (!menu) return
    // Swiper needs the container visible to measure widths, so build on open.
    menu.addEventListener('shown.bs.offcanvas', buildMenuBannerSwiper)
    if (menu.classList.contains('show')) buildMenuBannerSwiper()
  }

  if (document.readyState !== 'loading') {
    initMenuBanner()
  } else {
    document.addEventListener('DOMContentLoaded', initMenuBanner)
  }
})()

/* =====================================================================
   FEATURE 5 — Free gift on reaching a cart amount
   <free-gift> re-renders with the cart. It:
   - auto-removes the gift if the cart drops below the threshold
   - lets the customer add a chosen gift (with _free_gift property)
   ===================================================================== */
(function () {
  function routeAdd () { return (window.Shopify && Shopify.routes && Shopify.routes.cart_add_url) ? Shopify.routes.cart_add_url : '/cart/add' }
  function routeChange () { return (window.Shopify && Shopify.routes && Shopify.routes.cart_change_url) ? Shopify.routes.cart_change_url : '/cart/change' }

  // Refresh the cart drawer + badge using whatever the theme provides
  function refreshCart (data) {
    var cart = document.querySelector('cart-container')
    if (cart && typeof cart.reloadCartElements === 'function' && data && data.sections) {
      cart.reloadCartElements(data.sections)
    }
    window.dispatchEvent(new CustomEvent('kt.cart.added', { detail: data || {} }))
    var drawer = document.querySelector('#offcanvas-cart')
    if (drawer && window.bootstrap && window.bootstrap.Offcanvas) {
      window.bootstrap.Offcanvas.getOrCreateInstance(drawer).show()
    }
  }

  function postJSON (url, body) {
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d } }) })
  }

  // Delegated clicks — robust across every cart re-render
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return

    var chooseBtn = e.target.closest('.cart-free-gift-choose')
    if (chooseBtn) {
      e.preventDefault()
      e.stopPropagation()
      var id = Number(chooseBtn.dataset.variantId)
      if (!id) { chooseBtn.textContent = 'No variant id'; return }
      chooseBtn.textContent = 'Adding...'
      chooseBtn.classList.add('loading')
      chooseBtn.setAttribute('disabled', 'disabled')
      postJSON(routeAdd(), {
        items: [{ id: id, quantity: 1, properties: { _free_gift: 'true' } }],
        sections: ['cart-count-badge', 'offcanvas-cart'],
        sections_url: window.location.pathname
      }).then(function (res) {
        if (res.ok) {
          chooseBtn.textContent = 'Added'
          refreshCart(res.data)
        } else {
          chooseBtn.classList.remove('loading')
          chooseBtn.removeAttribute('disabled')
          chooseBtn.textContent = 'Error: ' + ((res.data && res.data.description) || 'failed')
          console.warn('[free-gift] add failed:', res.data)
        }
      }).catch(function (err) {
        chooseBtn.classList.remove('loading')
        chooseBtn.removeAttribute('disabled')
        chooseBtn.textContent = 'Network error'
        console.warn('[free-gift] add error:', err)
      })
      return
    }

    var removeBtn = e.target.closest('.cart-free-gift-remove')
    if (removeBtn) {
      e.preventDefault()
      var key = removeBtn.dataset.giftKey
      if (!key) return
      removeBtn.classList.add('loading')
      postJSON(routeChange(), {
        id: key, quantity: 0,
        sections: ['cart-count-badge', 'offcanvas-cart'],
        sections_url: window.location.pathname
      }).then(function (res) { if (res.ok) refreshCart(res.data) })
        .catch(function () {})
    }
  })

  // Auto-remove the gift when the cart drops below the threshold
  if (window.customElements && !window.customElements.get('free-gift')) {
    class FreeGift extends window.HTMLElement {
      connectedCallback () {
        if (this.dataset.reached === 'false' && this.dataset.giftInCart === 'true' && this.dataset.giftKey) {
          postJSON(routeChange(), {
            id: this.dataset.giftKey, quantity: 0,
            sections: ['cart-count-badge', 'offcanvas-cart'],
            sections_url: window.location.pathname
          }).then(function (res) { if (res.ok) refreshCart(res.data) }).catch(function () {})
        }
      }
    }
    window.customElements.define('free-gift', FreeGift)
  }
})()